import { createWorker } from "tesseract.js";

/**
 * Client-side handwriting/OCR helper.
 * Best-effort for printed/block writing; swap this module for a cloud API later.
 * @param {string} dataUrl PNG data URL from the handwriting canvas
 * @returns {Promise<string>} Recognized text (trimmed)
 */
export default async function recognizeHandwriting(dataUrl) {
  if (!dataUrl) return "";

  const worker = await createWorker("eng");
  try {
    const {
      data: { text },
    } = await worker.recognize(dataUrl);
    return String(text ?? "")
      .replace(/\s+/g, " ")
      .trim();
  } finally {
    await worker.terminate();
  }
}
